import React, { lazy } from "react";

export const JobsMetadata = {
  name: "Jobs",
  id: "jobs_list",
  component: lazy(() => import("../Jobs/Jobs")),
  route: "/jobs",
  Breadcrumbs: true,
};
